import { createPortal } from "react-dom";
import "./Process_modal.css";

export function Process_modal({ setShowModal }) {
  return createPortal(
    <div className="modal_overlay">
      <div className="main_process_section">
        <p>Active Threads</p>

        <p>Do you want to continue?</p>

        <div className="button_container">
          <button>Yes</button>
          <button onClick={() => setShowModal(false)}>Cancel</button>
        </div>
      </div>
    </div>,
    document.body,
  );
}
